// Shared academic dropdown options across registration flows
export const departmentOptions = [
  'Computer Science & Engineering',
  'Information Technology',
  'Electronics & Communication',
  'Electrical Engineering',
  'Mechanical Engineering',
  'Civil Engineering',
  'Chemical Engineering',
  'Biotechnology',
  'Other',
];

export const yearOptions = ['1st Year', '2nd Year', '3rd Year', '4th Year'];

export const roleOptions = [
  { value: 'student', label: 'Student' },
  { value: 'club_member', label: 'Club Member' },
  { value: 'admin', label: 'Admin' },
  { value: 'college_admin', label: 'College Admin' },
];
